import { QueryKey } from '@/constants/shared';
import { makeRequest } from '@/network/api';
import { GuardiansCampaignUserStats } from '@/types';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';

export const useGuardiansCampaignUserStats = () => {
  const { address } = useAuth();
  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.GuardiansOfPlumeUserStats, address],
    queryFn: async (): Promise<GuardiansCampaignUserStats | undefined> => {
      const campaignStatsRes = await makeRequest(`/campaigns/protectors-of-plume/user-stats`);

      if (campaignStatsRes.status === 404) {
        throw new Error('404 Not found');
      }
      const campaignResJson = await campaignStatsRes.json();

      return campaignResJson?.data;
    },
  });

  return {
    guardiansCampaignUserStats: data,
    guardiansCampaignUserPending: isPending,
    guardiansCampaignUserError: error,
    guardiansCampaignUserIsError: isError,
  };
};
